import { useParams } from "react-router-dom";

import { useGetCustomerQueryResponse } from "..";

import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { Customer } from "../models/Customer";

interface UseCustomerParams {
  customerId?: Customer["id"];
  options?: { skip: boolean };
}

export function useCustomer({ customerId, options }: UseCustomerParams = {}) {
  const { id } = useParams<ObjectWithId>();

  return useGetCustomerQueryResponse(customerId ?? id, options);
}
